import { FC, memo } from "react";
import { WithStyle } from "utils/WithStyle";
import { Progress, ProgressBarWrapper } from "./ProgressBar.styled";
import { ProgressBarProps } from "./types";

const Component: FC<ProgressBarProps> = memo(
    ({ progress, color, ...restProps }) => {
        return (
            <ProgressBarWrapper {...restProps}>
                <Progress progress={progress} color={color} />
            </ProgressBarWrapper>
        );
    }
);

export const ProgressBar: FC<ProgressBarProps> & WithStyle = Object.assign(
    Component,
    {
        Style: ProgressBarWrapper,
    }
);
